module.exports = __webpack_public_path__ + "static/media/vegitables_38.c5b5dd01.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_38.csv
// module id = 622
// module chunks = 0